import React from 'react';
import PropTypes from 'prop-types';
import TitleAndBreadCrumbs from './TitleAndBreadCrumbs';
import Search from './Search';

const Header = props => {
  const mainPageContent = props.structuredPSData?.content || {};
  const { searchBody, searchResult, searchTitle } = mainPageContent;
  return (
    <section id="appcenter-header">
      <div className="header-container">
        {props.appSearch.active ? null : <TitleAndBreadCrumbs {...props} />}
        <Search
          app={props.app}
          tools={props.flatPSData?.tools}
          categories={props.flatPSData?.categories}
          appSearch={props.appSearch}
          seoData={props.seo}
          dispatch={props.dispatch}
          updateSearchQuery={props.updateSearchQuery}
          updateSearchResults={props.updateSearchResults}
          clearSearch={props.clearSearch}
          setSearchActive={props.setSearchActive}
          fptiImpression={props.fptiImpression}
          fptiClick={props.fptiClick}
          content={{
            searchBody,
            searchResult,
            searchTitle
          }}
        />
      </div>
    </section>
  );
};

Header.propTypes = {
  app: PropTypes.object,
  structuredPSData: PropTypes.object,
  flatPSData: PropTypes.object.isRequired,
  appSearch: PropTypes.object,
  seo: PropTypes.object,
  dispatch: PropTypes.func,
  updateSearchQuery: PropTypes.func,
  updateSearchResults: PropTypes.func,
  clearSearch: PropTypes.func,
  setSearchActive: PropTypes.func,
  fptiImpression: PropTypes.func,
  fptiClick: PropTypes.func
};

export default Header;
